"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const nanoid_1 = require("nanoid");
const defaultElementAnimation_1 = __importDefault(require("./defaultElementAnimation"));
const shape_1 = require("../types/shape");
const element_1 = require("../types/element");
const background_1 = require("../types/background");
const adstudio_1 = require("../enums/adstudio");
function defaultShapeElement() {
    return {
        id: (0, nanoid_1.nanoid)(8),
        visible: true,
        isNew: true,
        active: false,
        playing: false,
        previewing: false,
        lock: false,
        type: element_1.ELEMENT_TYPE.SHAPE,
        background: {
            type: background_1.ELEMENT_BACKGROUND_TYPE.COLOR,
            value: '#097158',
        },
        angle: 0,
        y: 50,
        x: 50,
        externalLink: {
            isActive: false,
            value: '',
            elementName: '',
        },
        width: 500,
        height: 500,
        borderWidth: '0',
        outline: {
            color: '#000000',
            size: 0,
        },
        cornerRadius: 0,
        cornerRadiusUnit: adstudio_1.CORNER_RADIUS_UNITS_VALUES.PERCENTAGE,
        shapeType: shape_1.ELEMENT_SHAPE_TYPE.RECTANGLE,
        shadow: {
            x: 0,
            y: 0,
            color: '#000000',
            blur: 0,
        },
        opacity: 100,
        setMethod: 'setShape',
        animationCss: 'unset',
        fillType: 1,
        animationsTimeline: [(0, defaultElementAnimation_1.default)()],
    };
}
exports.default = defaultShapeElement;
